export default __webpack_public_path__ + "static/media/file-emerald.f79d085c.svg";